module.exports = __webpack_public_path__ + "static/img/4.f25f467.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/4.png
// module id = BJoY
// module chunks = 0